import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, XCircle, EyeOff, Activity } from 'lucide-react';
export function PainSection() {
  const symptoms = [{
    icon: EyeOff,
    text: 'Tus views cayeron 70–95% de golpe.'
  }, {
    icon: Activity,
    text: 'Casi no te llegan no-seguidores.'
  }, {
    icon: XCircle,
    text: 'Te bloquearon comentar/seguir/publicar (o te restringieron algo).'
  }, {
    icon: AlertTriangle,
    text: 'Tienes miedo de tocar cualquier cosa y empeorarlo.'
  }];
  return <section className="bg-[#0f0f0f] py-24" data-id="element-114">
      <div className="mx-auto max-w-4xl px-6" data-id="element-115">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12 text-center" data-id="element-116">
          <h2 className="text-3xl font-bold tracking-tight text-white md:text-4xl" data-id="element-117">
            Si hoy sientes esto…{' '}
            <span className="text-red-500" data-id="element-118">no eres el único</span>
          </h2>
        </motion.div>

        <div className="grid gap-6 md:grid-cols-2" data-id="element-119">
          {symptoms.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 rounded-lg border border-red-900/20 bg-red-950/10 p-6" data-id="element-120">
              <item.icon className="h-6 w-6 shrink-0 text-red-500" data-id="element-121" />
              <p className="text-lg text-gray-300" data-id="element-122">{item.text}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="mt-12 rounded-xl bg-[#1a1a1a] p-8 text-center" data-id="element-123">
          <p className="text-lg text-gray-400" data-id="element-124">
            Te pasas horas buscando “tips” y terminas más confundido.
            <br data-id="element-125" />Y encima, el peor pensamiento:
          </p>
          <p className="mt-4 text-2xl font-bold italic text-white" data-id="element-126">
            “Si esto sigue una semana más, me quedo sin dinero.”
          </p>
        </motion.div>
      </div>
    </section>;
}